export const DataPropType = Object.freeze({
  Number: "Number",
  WeekDays: "WeekDays",
  Date: "Date",
  DateShort: "DateShort",
  String: "String",
  HTMLString: "HTMLString",
  Object: "Object",
  Money: "Money",
  Money4digits: "Money4digits",
  QTY: "QTY",
  Month: "Month",
  MonthShort: "MonthShort",
  BOOL: "Boolean",
  Color: "Color",
  None: "None",
  Identificator: "Identificator",
});

export const DataFilterType = Object.freeze({
  //Null: { id: -1, text: "" },
  Contains: { id: 0, text: " съдържа " },
  Equals: { id: 1, text: " = " },
  LessThan: { id: 2, text: " < " },
  MoreThan: { id: 3, text: " > " },
  Between: { id: 4, text: " е между " },
  In: { id: 5, text: " = " },
  WeekDays: { id: 6, text: " = " },
});

export class DataFilter {
  /**
   * @param {string} propname
   * @param {string} text
   * @param {DataFilterType} type
   * @param {DataPropType} proptype
   * @param {Array} vals
   * @memberof DataFilter
   */
  constructor(propname = null, text = null, type = null, proptype = null, vals = null) {
    this.propname = propname;
    this.text = text;
    this.type = type;
    this.proptype = proptype;
    if (vals) this.vals = vals.slice();
    // else this.vals = [];
  }

  toString() {
    var len = this.vals.length;
    if (this.type == DataFilterType.In || this.type == DataFilterType.WeekDays) {
      var txt = "";
      this.vals.forEach((e, idx) => {
        if (idx + 1 == len) txt += e;
        else txt += e + ", ";
      });
      return "'" + this.text + "'" + this.type.text + "[" + txt + "]";
    } else if (this.type == DataFilterType.Equals && this.proptype == DataPropType.BOOL) {
      return this.text + this.type.text + (this.vals[0] == true ? "Да" : this.vals[0] == false ? "Не" : "");
    } else if (len == 1) {
      if (this.proptype == DataPropType.Date) {
        return "'" + this.text + "'" + this.type.text + this.vals[0].toTremolFpStringShort();
      } else {
        return "'" + this.text + "'" + this.type.text + this.vals[0];
      }
    } else if (len == 2) {
      if (this.proptype == DataPropType.Date) {
        return "'" + this.text + "'" + this.type.text + (this.vals[0] ? this.vals[0].toTremolFpStringShort() : "") + " и " + (this.vals[1] ? this.vals[1].toTremolFpStringShort() : "");
      } else {
        return "'" + this.text + "'" + this.type.text + this.vals[0] + " и " + this.vals[1];
      }
    } else if (this.text == null) {
      return "Не е избрано поле за филтриране!";
    } else return "Невалиден филтър за поле " + "'" + this.text + "'";
  }
}
